import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import TrIsLogo from "../assets/collaboration/tr-is.png";
import DDMLogo from "../assets/collaboration/ddm.png";
import TurkonfedLogo from "../assets/collaboration/turkonfed.png";
import EbLogo from "../assets/collaboration/eb.png";
import FrankfurtLogo from "../assets/collaboration/frankfurt.png";
import QatarLogo from "../assets/collaboration/qatar.png";
import KobiLogo from "../assets/collaboration/kobi.png";
import SparkLogo from "../assets/collaboration/spark.png";
import languageStorage from "../lang/findLanguage";
export default function Collaboration({ language }) {
  const images = [
    {
      id: 1,
      src: TrIsLogo,
    },
    {
      id: 2,
      src: DDMLogo,
    },
    {
      id: 3,
      src: TurkonfedLogo,
    },
    {
      id: 4,
      src: EbLogo,
    },
    {
      id: 5,
      src: FrankfurtLogo,
    },
    {
      id: 6,
      src: QatarLogo,
    },
    {
      id: 7,
      src: KobiLogo,
    },
    {
      id: 8,
      src: SparkLogo,
    },
  ];

  return (
    <div className='collaboration d-flex align-items-center justify-content-center flex-column'>
      <h3>
        {languageStorage() === "tr"
          ? language[0].sections[4].keys[0].k0001
          : language[1].sections[4].keys[0].k0001}
      </h3>
      <div className='logo d-flex align-items-center justify-content-center flex-wrap'>
        {images.map((item) => (
          <LazyLoadImage
            key={item.id}
            alt=''
            height={46}
            src={item.src}
            width={106}
          />
        ))}
      </div>
    </div>
  );
}
